export let DirectLineSenderRole;
(function (DirectLineSenderRole) {
  DirectLineSenderRole["User"] = "user";
  DirectLineSenderRole["Bot"] = "bot";
  DirectLineSenderRole["Channel"] = "channel";
})(DirectLineSenderRole || (DirectLineSenderRole = {}));